import { render, staticRenderFns } from "./RunCenterTask.vue?vue&type=template&id=9ef95438&scoped=true"
import script from "./RunCenterTask.vue?vue&type=script&lang=js"
export * from "./RunCenterTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef95438",
  null
  
)

export default component.exports